<div id="header">
    <div>
        <input class="header-menu-button" type="button" (click)="navigateTo('upload')" value="Upload testing" />

        <input class="header-menu-button" type="button" (click)="navigateTo('redaction')" value="Redaction testing" />

        <input class="header-menu-button" type="button" (click)="navigateTo('redactthefact/485586/82729')" value="Redact The Fact" />
    </div>
</div>



<router-outlet />